import { get } from 'lib/reduxHelpers/thunks'
import { calculationsTypes } from 'actions/types'

function fetchCalculations() {
  let baseType = calculationsTypes.FETCH_CALCULATIONS
  let url = `${process.env.REACT_APP_API_URL}/calculations`
  return get({ baseType, url })
}

export { fetchCalculations }